import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from '../../app/modules/auth'
import * as fiscalYear from '../../app/modules/tahun-anggaran'
import * as rfSatuanIndikator from '../../app/modules/rf-satuan-indikator'
import * as rfSatuanKerja from "../../app/modules/rf-satuan-kerja";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  fiscalYear: fiscalYear.reducer,
  rfSatuanIndikator: rfSatuanIndikator.reducer,
  rfSatuanKerja: rfSatuanKerja.reducer
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga(), rfSatuanIndikator.saga(), rfSatuanKerja.saga(), fiscalYear.saga()])
}
